/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyEntryDto } from '../models/CompanyEntryDto';
import type { ContactPersonSelectOptionDto } from '../models/ContactPersonSelectOptionDto';
import type { LoadEmailSelectOptionsRequestDto } from '../models/LoadEmailSelectOptionsRequestDto';
import type { OfficeSelectOptionDto } from '../models/OfficeSelectOptionDto';
import type { SelectOptionRequestDto } from '../models/SelectOptionRequestDto';
import type { SelectOptionsRequestDto } from '../models/SelectOptionsRequestDto';
import type { SimpleSelectOptionDto } from '../models/SimpleSelectOptionDto';
import type { SocialLinkSelectOptionDto } from '../models/SocialLinkSelectOptionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SelectOptionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns OfficeSelectOptionDto
     * @throws ApiError
     */
    public getOfficeOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<OfficeSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/offices',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ContactPersonSelectOptionDto
     * @throws ApiError
     */
    public getExternalContactPersonOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<ContactPersonSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/external-contact-persons',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyEntryDto
     * @throws ApiError
     */
    public loadExternalContactPersonEmailOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: LoadEmailSelectOptionsRequestDto,
    }): CancelablePromise<CompanyEntryDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/external-contact-persons/{id}/emails/load',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyEntryDto
     * @throws ApiError
     */
    public loadContactPersonEmailOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: LoadEmailSelectOptionsRequestDto,
    }): CancelablePromise<CompanyEntryDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/contact-persons/{id}/emails/load',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getExternalContactPersonEmailOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/external-contact-persons/{id}/emails',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getExternalContactPersonLinkedinProfileOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/external-contact-persons/{id}/linkedin-profiles',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ContactPersonSelectOptionDto
     * @throws ApiError
     */
    public getContactPersonPositionOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<ContactPersonSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/contact-persons',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getContactPersonEmailOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/contact-persons/{id}/emails',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getContactPersonPhoneNumberOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/contact-persons/{id}/phone-numbers',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getContactPersonLinkedinProfileOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/contact-persons/{id}/linkedin-profiles',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getOfficeEmailOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/offices/{id}/emails',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getOfficePhoneNumberOptions({
        companyId,
        id,
        requestBody,
    }: {
        companyId: string,
        id: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/offices/{id}/phone-numbers',
            path: {
                'company_id': companyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getCompanyEmailOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/emails',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SocialLinkSelectOptionDto
     * @throws ApiError
     */
    public getCompanyLinkedinSocialOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SocialLinkSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/linkedin-socials',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getCompanyPhoneNumberOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/phone-numbers',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SimpleSelectOptionDto
     * @throws ApiError
     */
    public getWebsiteOptions({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionsRequestDto,
    }): CancelablePromise<Array<SimpleSelectOptionDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{company_id}/select-options/websites',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyEntryDto
     * @throws ApiError
     */
    public selectOption({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SelectOptionRequestDto,
    }): CancelablePromise<CompanyEntryDto> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/companies/{company_id}/select-options',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
